export type DayOfWeek = 0 | 1 | 2 | 3 | 4 | 5 | 6; // 0 = Sunday

export interface DaySchedule {
  enabled: boolean;
  /** HH:mm */
  from: string;
  /** HH:mm */
  to: string;
}

export type WeeklySchedule = Record<DayOfWeek, DaySchedule>;

export const DEFAULT_WEEKLY_SCHEDULE: WeeklySchedule = {
  0: { enabled: false, from: '09:00', to: '18:00' },
  1: { enabled: true,  from: '09:00', to: '18:00' },
  2: { enabled: true,  from: '09:00', to: '18:00' },
  3: { enabled: true,  from: '09:00', to: '18:00' },
  4: { enabled: true,  from: '09:00', to: '18:00' },
  5: { enabled: true,  from: '09:00', to: '18:00' },
  6: { enabled: false, from: '09:00', to: '18:00' },
};

export const DAY_NAMES: Record<DayOfWeek, string> = {
  0: 'Domingo',
  1: 'Lunes',
  2: 'Martes',
  3: 'Miércoles',
  4: 'Jueves',
  5: 'Viernes',
  6: 'Sábado',
};

export const SLOT_DURATION_MINUTES = 30;
